import { render, staticRenderFns } from "./Dj.vue?vue&type=template&id=ddb8ae58&scoped=true"
import script from "./Dj.vue?vue&type=script&lang=js"
export * from "./Dj.vue?vue&type=script&lang=js"
import style0 from "./Dj.vue?vue&type=style&index=0&id=ddb8ae58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8ae58",
  null
  
)

export default component.exports